export default __webpack_public_path__ + "static/media/electric3.43a85fc8.jpg";